module.exports = __webpack_public_path__ + "static/img/bg-en.f3e588e1.png";